export default __webpack_public_path__ + "static/4.Clementi Woods KLLP-3da93c7e0fddbb057b8218df5174e66a.png";